import React from 'react';

import IconGrid from './desktop-components/DesktopIcon';
import StartMenu from './desktop-components/StartMenu';
import Taskbar from './desktop-components/Taskbar';
import ApplicationWindow from './desktop-components/ApplicationWindow';
import SecondaryWindow from './desktop-components/SecondaryWindow';
import Screensaver from "./desktop-components/Screensaver"

import {allApplications} from './applications/ApplicationList.js';
import {changeToLightTheme, changeToDarkTheme, changeToPurpleTheme, changeToGreenTheme} from "./desktop-components/ThemeChanger"

import './App.css';

function App() {
  return (
   <div id="screen">
    <Screensaver />
    <Desktop />
   </div>
  );
}

class Desktop extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startMenuOpen: false,
      openApplications: [],
      maxZIndex: 2,
      desktopSize: {
        width: window.innerWidth,
        height: window.innerHeight
      }
    };
    this.changeDesktopSize = this.changeDesktopSize.bind(this);
    this.startButtonHandler = this.startButtonHandler.bind(this);
    this.appLauncherHandler = this.appLauncherHandler.bind(this);
    this.appMinimizeHandler = this.appMinimizeHandler.bind(this);
    this.appExitHandler = this.appExitHandler.bind(this);
    this.appFocusHandler = this.appFocusHandler.bind(this);
    window.addEventListener('resize', this.changeDesktopSize);
    if(sessionStorage.getItem('themeSelection.file')) {
      let theme = sessionStorage.getItem('themeSelection.file');
      this.themeHandler(theme);
    }
    else {
      changeToLightTheme();
    }
  }

  themeHandler(themeName) {
    if(themeName === 'light') {
      changeToLightTheme();
    }
    if(themeName === 'dark') {
      changeToDarkTheme();
    }
    if(themeName === 'purple') {
      changeToPurpleTheme();
    }
    if(themeName === 'green') {
      changeToGreenTheme();
    }
  }

  startButtonHandler() {
    this.setState(prevState => ({
        startMenuOpen: !prevState.startMenuOpen,
    }));
  }

  appLauncherHandler(event, appName, propMethod = null, filename = null) {
    if(event !== null) {
      event.stopPropagation();
    }
    let appIndex = this.state.openApplications.indexOf(null);
    let appObject = allApplications.find(obj => obj.name === appName);
    let appZIndex = 1;
    if(appObject.windowType === "Secondary") {
      appZIndex = 999;
    }
    let newApp = {
      name: appName,
      appObject: appObject,
      filename: filename,
      propMethod: propMethod,
      zIndex: appZIndex
    };
    if(appIndex === -1) {
      this.setState({
          openApplications: [...this.state.openApplications, newApp],
          startMenuOpen: false,
      });
    }
    else {
      let updatedAppArray = this.state.openApplications;
      updatedAppArray[appIndex] = newApp;
      this.setState({
          openApplications: updatedAppArray,
          startMenuOpen: false,
      });
    }
  }

  appMinimizeHandler(event, appIndex) {
    if(event !== null) {
      event.stopPropagation();
    }
    let updatedAppArray = this.state.openApplications;
    updatedAppArray[appIndex].zIndex = -1;
    this.setState({
        openApplications: updatedAppArray,
    });
  }

  appExitHandler(event, appIndex) {
    if(event !== null) {
      event.stopPropagation();
    }
    let updatedAppArray = this.state.openApplications;
    updatedAppArray[appIndex] = null;
    this.setState({
        openApplications: updatedAppArray,
    });
    if(this.state.openApplications.every(element => element === null)) {
      this.setState({
          openApplications: [],
          maxZIndex: 2
      });
    }
  }

  appFocusHandler(appIndex) {
    if(this.state.openApplications[appIndex].zIndex !== this.state.maxZIndex) {
      let updatedAppArray = this.state.openApplications;
      let newMaxZIndex = this.state.maxZIndex + 1;
      updatedAppArray[appIndex].zIndex = this.state.maxZIndex + 1;
      this.setState({
          openApplications: updatedAppArray,
          maxZIndex: newMaxZIndex
      });
    }
  }

  changeDesktopSize() {
    this.setState({
      desktopSize: {
        width: window.innerWidth,
        height: window.innerHeight
      }
    });
  }

  render() {
    return (
      <div id="desktop" data-testid="desktop">
        <StartMenu
          startButtonHandler = {this.startButtonHandler}
          appLauncherHandler = {this.appLauncherHandler}
          status = {this.state.startMenuOpen}
        />
        {this.state.openApplications.map((value, index) => {
          if(value != null) {
            if(value.appObject.windowType === "Application") {
              return (
                <ApplicationWindow
                  arrayIndex = {index}
                  appObject = {value.appObject}
                  desktopSize = {this.state.desktopSize}
                  zIndex = {value.zIndex}
                  filename = {value.filename}
                  propMethod = {value.propMethod}
                  appMinimizeHandler = {this.appMinimizeHandler}
                  appExitHandler = {this.appExitHandler}
                  appFocusHandler = {this.appFocusHandler}
                  appLauncherHandler = {this.appLauncherHandler}
                  key={index}
                />
              );
            }
            if(value.appObject.windowType === "Secondary") {
              return(
                <SecondaryWindow
                  arrayIndex = {index}
                  appObject = {value.appObject}
                  desktopSize = {this.state.desktopSize}
                  zIndex = {value.zIndex}
                  filename = {value.filename}
                  propMethod = {value.propMethod}
                  appExitHandler = {this.appExitHandler}
                  appLauncherHandler = {this.appLauncherHandler}
                  key={index}
                />
              );
            }
            else {
              return(null);
            }
          }
          else {
            return(null);
          }
        })}

        <Taskbar
          startButtonHandler = {this.startButtonHandler}
          appFocusHandler = {this.appFocusHandler}
          appMinimizeHandler = {this.appMinimizeHandler}
          openApplications = {this.state.openApplications}
          zIndexes = {this.state.zIndexes}
        />

        <IconGrid
          appLauncherHandler = {this.appLauncherHandler}
        />
      </div>
    );
  }
}


export default App;
